const { useMatches } = require("react-router-dom");

export const RouterMatches = () => {
    let matches = useMatches();

    let crumbs = matches
        // first get rid of any matches that don't have handle and crumb
        .filter((match) => {
            return Boolean(match.handle?.crumb)
        })
        // now map them into an array of elements, passing the loader
        // data to each one
        .map((match) => {
            return {
                path: match.pathname,
                crumb: match.handle.crumb(match.data)
            }
            // return match.handle.crumb(match.data) || match.pathname
        });

    let dataLoader = matches
        .filter((match) => {
            return Boolean(match.data)
        })
        .map((match) => {
            return match.data
        });

    return {
        dataLoader: dataLoader ? dataLoader[0] ?? null : null,
        crumbs
    }
}
